import ApiService from "./ApiService";

export default class GateWayService {
  static getPaymentGateways = () => ApiService.get("/admin/payment-gateways");

  static updatePaymentGateway = (gatewayId) =>
    ApiService.post("/admin/payment-gateway-setting",gatewayId);
}
